import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Shield, Loader2 } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { Input } from '@/app/components/ui/input';
import { useAdminLogin } from '@/api';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const adminLogin = useAdminLogin();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await adminLogin.mutateAsync({ username, password });
      navigate('/admin');
    } catch {
      // Error shown below
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      {/* Background gradients matching main app */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,rgba(255,140,66,0.06),transparent_50%)]" />
        <div className="absolute bottom-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,rgba(74,158,255,0.04),transparent_50%)]" />
      </div>

      <div className="relative z-10 w-full max-w-md">
        <div className="flex flex-col items-center mb-10">
          <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mb-5 border border-white/[0.08]">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-['Poppins',sans-serif] text-3xl font-semibold text-white mb-2">
            Admin Login
          </h1>
          <p className="text-[#9595a5]">Restricted access</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="p-8 rounded-2xl bg-[#18181f] border border-white/[0.08] space-y-6"
        >
          <div>
            <label className="block text-sm font-medium text-white mb-2">Username</label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Admin username"
              className="w-full bg-[#2a2a35] border-white/[0.08] text-white placeholder-[#9595a5] focus:border-white/30"
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-white mb-2">Password</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Admin password"
              className="w-full bg-[#2a2a35] border-white/[0.08] text-white placeholder-[#9595a5] focus:border-white/30"
              autoComplete="current-password"
              required
            />
          </div>
          {adminLogin.isError && (
            <p className="text-sm text-red-400">{adminLogin.error.message}</p>
          )}
          <Button
            type="submit"
            disabled={adminLogin.isPending}
            className="w-full bg-white text-black hover:opacity-90 font-medium py-6 rounded-xl"
          >
            {adminLogin.isPending ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              'Sign in'
            )}
          </Button>
        </form>

        <p className="text-center text-sm text-[#9595a5] mt-8">
          <a href="/" className="hover:text-white transition-colors">← Back to app</a>
        </p>
      </div>
    </div>
  );
}
